import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { Button } from '../button';
import { PictureIcon } from '../icons/content/picture-icon';
import { TrashIcon } from '../icons/content/trash-icon';
import { RefreshIcon } from '../icons/internet/refresh-icon';
/**
 * @description File Upload API events by the link https://react-dropzone.js.org
 */
export const Upload = ({ label, onRemove, dropzone, fileUploaded, ref, ...props }) => {
    const [file, setFile] = useState();
    const fileSizeMb = dropzone.maxSize ? dropzone.maxSize / 1024 / 1024 : 0;
    useEffect(() => {
        setFile(fileUploaded);
    }, [fileUploaded]);
    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
        ...dropzone,
        multiple: false,
        onDrop: (acceptedFiles, fileRejections, event) => {
            for (const acceptedFile of acceptedFiles) {
                const file = {
                    id: 0,
                    url: URL.createObjectURL(acceptedFile),
                };
                setFile(file);
            }
            if (dropzone.onDrop) {
                dropzone.onDrop(acceptedFiles, fileRejections, event);
            }
        },
    });
    const onRemoveClick = () => {
        setFile(null);
        if (onRemove) {
            onRemove();
        }
    };
    const onUploadClick = () => open();
    if (file) {
        return (_jsx(Root, { "$active": isDragActive, ref: ref, children: _jsxs(InnerContainer, { children: [_jsx("img", { src: file.url }), _jsx("input", { ...getInputProps() }), _jsxs(Nav, { children: [_jsx(ButtonRemove, { size: "s", variant: "secondary", type: "button", iconLeft: _jsx(TrashIcon, { size: 20, color: "red" }), onClick: onRemoveClick }), _jsx(ButtonReplace, { size: "s", variant: "secondary", type: "button", iconLeft: _jsx(RefreshIcon, { size: 20 }), onClick: onUploadClick, children: label.replace })] })] }) }));
    }
    return (_jsx(Root, { "$active": isDragActive, ref: ref, ...getRootProps(), ...props, children: _jsxs(InnerContainer, { children: [_jsx("input", { ...getInputProps() }), _jsxs(Info, { children: [_jsx(Icon, { children: _jsx(PictureIcon, { width: 24, height: 24 }) }), _jsx(TextFileType, { children: label.title }), fileSizeMb > 0 && (_jsx(TextFileSize, { children: `< ${fileSizeMb} Mb` }))] }), _jsx(Nav, { children: _jsx(ButtonUpload, { size: "s", variant: "secondary", type: "button", children: label.upload }) })] }) }));
};
const Root = styled.div `
  border: 1px dashed
    ${(props) => props.$active ? props.theme.color.gray3 : props.theme.color.white[25]};

  position: relative;
  cursor: copy;
  text-align: center;

  padding: 2px;
  border-radius: 23px;
  transition: all 100ms ease-in-out;

  img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }

  &:hover {
    border-color: ${(props) => props.theme.color.gray3};
  }
`;
const InnerContainer = styled.div `
  background: ${(props) => props.theme.color.black2[100]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 160px;
  width: 160px;
  border-radius: 20px;
  gap: 15px;
  padding: 25px 0 15px;
`;
const Info = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Nav = styled.div `
  display: flex;
  gap: 5px;
`;
const Icon = styled.div `
  color: ${(props) => props.theme.color.white[100]};
`;
const TextFileType = styled.p `
  color: ${(props) => props.theme.color.white[100]};
  font-size: 12px;
`;
const TextFileSize = styled.p `
  color: ${(props) => props.theme.color.gray3};
  font-size: 12px;
`;
const ButtonRemove = styled(Button) `
  background: ${(props) => props.theme.color.black3[100]};
  border: 0;
  padding: 0 10px;
`;
const ButtonReplace = styled(Button) `
  padding: 0 12px;
`;
const ButtonUpload = styled(Button) `
  padding: 0 30px;
`;
//# sourceMappingURL=upload.js.map